import styles from './MenuButton.scss';

import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface MenuButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  isOpen?: boolean;
}

const MenuButton = React.forwardRef<HTMLButtonElement, MenuButtonProps>(({
  isOpen = false,
  className,
  ...props
}, ref) => {
  const { t } = useTranslation();

  const label = t((isOpen ? 'hide-menu' : 'expand-menu-for-more'));

  return (
    <button
      data-test="menu-button"
      aria-label={label}
      className={cx(styles.menuButton, className, {
        [styles.menuButtonActive]: isOpen,
      })}
      ref={ref}
      {...props}
    >
      <div className={styles.menuButtonIcon}>
        <span className={styles.menuButtonIconDash} />
        <span className={styles.menuButtonIconDash} />
        <span className={styles.menuButtonIconDash} />
      </div>
    </button>
  );
});

MenuButton.displayName = 'MenuButton';

export { MenuButton };
